// app/javascript/entrypoints/application.js

// Configure your import map in config/importmap.rb. Read more: https://github.com/rails/importmap-rails
import "@hotwired/turbo-rails"
import { Application } from "@hotwired/stimulus"
import { registerControllers } from "stimulus-vite-helpers"

const application = Application.start()

// Register all controllers from controllers/**/*_controller.js
const controllers = import.meta.glob("../controllers/**/*_controller.js", { eager: true })
const myControllers = import.meta.glob("../my_controllers/**/*_controller.js", { eager: true })

registerControllers(application, controllers)
registerControllers(application, myControllers)

// Configure Stimulus development experience
if (import.meta.env.DEV) {
	application.debug = true
	window.Stimulus = application
}

// Import existing polyfills
import "formdata-polyfill"

let formSubmissionInFlight = false
let busyMethodLinks = new WeakSet()
const busyForms = new WeakSet()

document.addEventListener("click", (event) => {
	if (!(event.target instanceof Element)) return

	const link = event.target.closest("a[data-turbo-method]")
	if (!link) return

	if (formSubmissionInFlight || busyMethodLinks.has(link)) {
		event.preventDefault()
		event.stopImmediatePropagation()
		return
	}

	busyMethodLinks.add(link)
	setTimeout(() => busyMethodLinks.delete(link), 5000)
}, true)

document.addEventListener("submit", (event) => {
	const form = event.target
	if (!(form instanceof HTMLFormElement)) return

	if (busyForms.has(form)) {
		event.preventDefault()
		event.stopImmediatePropagation()
		return
	}

	busyForms.add(form)
	setTimeout(() => busyForms.delete(form), 30000)
}, true)

document.addEventListener("turbo:submit-start", () => {
	formSubmissionInFlight = true
})

document.addEventListener("turbo:submit-end", (event) => {
	formSubmissionInFlight = false
	busyMethodLinks = new WeakSet()

	const form = event.target
	if (form instanceof HTMLFormElement) busyForms.delete(form)
})

const releaseBusyElements = () => {
	formSubmissionInFlight = false
	busyMethodLinks = new WeakSet()
	document.querySelectorAll("form").forEach((form) => busyForms.delete(form))
}

document.addEventListener("turbo:fetch-request-error", releaseBusyElements)
document.addEventListener("turbo:load", releaseBusyElements)